import Vue from "vue";

const preventReClick = Vue.directive("preventReClick", {
  inserted(el, binding) {
    el.addEventListener("click", () => {
      if (!el.disabled) {
        el.disabled = true;
        setTimeout(() => {
          el.disabled = false;
        }, binding.value || 3000);
      }
    });
  },
});

export { preventReClick };



// WEBPACK FOOTER //
// ./src/assets/utils/resubmit.js